<section class="uscb-margin-TB-5 uscb-margin-LR-0 linear-loading">
    @if (!loading) {
    <mat-divider class="uscb-border-primary" role="presentation"></mat-divider>
    }
    @if (loading) {
    <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
    }
</section>
